import { IConfigDataRequest, IConfigDataResponse } from "interfaces/IConfig"
import { api as apiService, ApiService } from "./api"
import { promises } from "dns"

class ConfigsService {
  constructor(private readonly api: ApiService) {}

  public getConfig = async (): Promise<IConfigDataResponse> => {
    return await this.api.get(toranjaURL + "/config/")
  }

  public postConfig = async (data: IConfigDataRequest): Promise<IConfigDataResponse> => {
    return await this.api.post(toranjaURL + "/config/", data)
  }
}
const toranjaURL = process.env.REACT_APP_TORANJA_API
export const configsService = new ConfigsService(apiService)
